import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-menu-style3',
  templateUrl: './menu-style3.component.html',
  styleUrls: ['./menu-style3.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuStyle3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/mega-menu/menu-style3/menu-style3.component.ts